import React from 'react';
import { SettingCheckBox, SettingsHeader } from '../Settings';
import './../Setting.scss';
import './Notifications.scss';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const Notifications = ({ handleBackToSetting }) => {
    const settingsData = useSelector((state) => state.settingsData.data?.Notifications);
    
    return (
        <div className="setting-container">
            <div>
                <div className="settinglist">
                    <SettingsHeader
                        label={'Notifications'}
                        handleBackFromSetting={handleBackToSetting}
                    />
                    <ul className="setting-list-ul notifications">
                        {
                        //hidden due to functionality  issue
                        /* <SettingCheckBox
                            id="Sound"
                            label="Sound"
                        /> */}
                        <SettingCheckBox
                            id="Notifications"
                            label="Notifications"
                            dafaultSetting={settingsData}
                        />
                    </ul>
                </div>

            </div>
        </div>
    );
};

Notifications.propTypes = {
    handleBackToSetting: PropTypes.func,
};

export default Notifications;